import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'YouTube', href: '#videos' },
  { label: 'Listings', href: '#listings' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-white border-b border-[#E8E0D0]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); handleNavClick('#home'); }}
          className="flex items-center gap-3 cursor-pointer"
        >
          <img
            src="https://public.readdy.ai/ai/img_res/ad91bbaa-5738-4ac8-829f-abe55c8dec23.png"
            alt="김산 부동산 Shawn Kim Real Estate Logo"
            className="h-12 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap hover:text-[#B8963E] ${
                scrolled ? 'text-[#1A1A1A]' : 'text-white'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Phone CTA */}
        <a
          href="tel:4049340670"
          className="hidden lg:flex items-center gap-2 bg-[#B8963E] text-white px-5 py-2.5 rounded-md text-sm font-semibold hover:bg-[#A07830] transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-phone-fill text-sm"></i>
          (404) 934-0670
        </a>

        {/* Mobile Menu Button */}
        <button
          className={`lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? 'text-[#1A1A1A]' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-[#E8E0D0] px-6 py-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="block py-3 text-[#1A1A1A] text-sm font-medium border-b border-[#F0EBE0] last:border-0 hover:text-[#B8963E] transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="tel:4049340670"
            className="mt-4 flex items-center justify-center gap-2 bg-[#B8963E] text-white px-5 py-3 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill"></i>
            (404) 934-0670
          </a>
        </div>
      )}
    </header>
  );
}
